export default __webpack_public_path__ + "static/media/connect-full-transparent.e0029eea.gif";